import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Ellipses(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
            viewBox='0 0 27 31'
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <title>Layer 1</title>
                    <g id='Layer_2'>
                        <g
                            fill={iconColor || '#000000'}
                            id='Layer_1-2'
                        >
                            <circle
                                cx='12.08184'
                                cy='4'
                                id='svg_1'
                                r='2.22'
                            />
                            <circle
                                cx='12.08184'
                                cy='13.5'
                                id='svg_2'
                                r='2.22'
                            />
                            <circle
                                cx='12.08184'
                                cy='23'
                                id='svg_3'
                                r='2.22'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}